var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigitization04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3074_84171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3988 16.5183H34.5232C36.9097 16.5183 38.8444 14.5836 38.8444 12.1971C38.8444 10.3059 37.6275 8.70253 35.9356 8.11675C35.6968 5.95601 33.8667 4.27494 31.6424 4.27494C31.0094 4.27494 30.41 4.41429 29.8682 4.65894C28.5013 2.27987 25.9406 0.673918 23 0.673918C19.9198 0.673918 17.2566 2.43539 15.946 5.00259C15.8963 5.00133 15.848 4.99513 15.798 4.99513C12.616 4.99513 10.0364 7.57473 10.0364 10.7567C10.0364 13.9387 12.616 16.5183 15.798 16.5183H16.5185",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0414 44.606H20.8394C19.6461 44.606 18.6789 43.6386 18.6789 42.4454V38.1242C18.6789 36.9309 19.6461 35.9636 20.8394 35.9636H28.0414C29.2347 35.9636 30.202 36.9309 30.202 38.1242V42.4454C30.202 43.6386 29.2347 44.606 28.0414 44.606Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0991 39.995L23.5019 38.4955C23.2788 38.3668 23 38.5277 23 38.7854V41.7843C23 42.0418 23.2788 42.2028 23.5019 42.0741L26.0991 40.5746C26.3222 40.4458 26.3222 40.1238 26.0991 39.995Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87582 45.3262C7.87582 44.5307 7.23092 43.8858 6.43544 43.8858H2.11423V36.6838H6.43544C7.23092 36.6838 7.87582 37.3286 7.87582 38.1242V41.005",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87582 45.3262C7.87582 44.5307 8.52072 43.8858 9.3162 43.8858H13.6374V36.6838H9.3162C8.52072 36.6838 7.87582 37.3286 7.87582 38.1242",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.404 43.1656C37.404 43.9611 36.7591 44.606 35.9636 44.606C35.1681 44.606 34.5233 43.9611 34.5233 43.1656C34.5233 42.3701 35.1681 41.7252 35.9636 41.7252C36.7591 41.7252 37.404 42.3701 37.404 43.1656Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8858 41.7252C43.8858 42.5206 43.2409 43.1655 42.4454 43.1655C41.6499 43.1655 41.0051 42.5206 41.0051 41.7252C41.0051 40.9297 41.6499 40.2848 42.4454 40.2848C43.2409 40.2848 43.8858 40.9297 43.8858 41.7252Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.404 43.1655V38.0622C37.404 37.0496 38.1073 36.1728 39.0959 35.9531L43.058 35.0727C43.4828 34.9782 43.8858 35.3015 43.8858 35.7366V41.7252",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87582 33.803V26.601C7.87582 25.8054 8.52072 25.1606 9.3162 25.1606H39.5646C40.3601 25.1606 41.005 25.8054 41.005 26.601V32.3626",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4404 33.0828V16.5182",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3074_84171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitization04);
export default __webpack_public_path__ + "static/media/Digitization04.07949607a4fc8653c70622f1486644ce.svg";
export { ForwardRef as ReactComponent };